export const ProductTypeIdApi = {
  Course: 1,
  Accommodation: 2,
  AddOn: 3,
  Transfer: 4,
  Fee: 5,
  Package: 6,
} as const;

export const SelectionModeApi = {
  NoSelectionMode: 0,
  SpecificProductType: 1,
  IncludeSelected: 2,
  ExcludeSelected: 3,
  IncludeAll: 4,
} as const;

export const CommissionProductSelectMode = {
  Any: 0,
  Type: 1,
  Select: 2,
} as const;

export interface ProductSelectionDto {
  productTypeId: number;
  accommodationTypeIds: number[];
  addOnTypeIds: number[];
  productIds: number[];
  selectionMode: number;
  minDuration?: number;
  maxDuration?: number;
}

export interface CommissionGroupDto {
  id: number;
  name: string;
  productSelections: ProductSelectionDto[];
  feeIds: number[];
  active?: boolean;
}

export interface CommissionGroupApiResponse {
  id?: number;
  name?: string;
  applicableProduct?: ApplicableProductApi[];
  applicableProductExcluded?: ApplicableProductApi[];
  feeIds?: number[];
}

export interface ApplicableProductApi {
  productTypeName?: string;
  selectionMode?: string | number;
  productIds?: (number | string)[];
  accommodationTypeIds?: number[];
  addOnTypeIds?: number[];
  minDuration?: number;
  maxDuration?: number;
}

export interface CommissionGroupsRequest {
  commissionGroups: CommissionGroupDto[];
}